import HeaderFlexContent from './HeaderFlexContent';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

HeaderFlexContent.schema = schema;
HeaderFlexContent.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default HeaderFlexContent;
